import React from 'react';

class NotFound extends React.Component {
  render() {
    return <div>White box, not found</div>;
  }
}

export default NotFound;
